// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".items_group_more[data-v-beedd06c]{color:rgba(100,119,136,.7);cursor:pointer}", ""]);
// Exports
module.exports = exports;
